import React, {Component} from 'react'
import './style.css'
import _ from 'lodash'
import {Route, Switch} from 'react-router-dom'
import {Helmet} from 'react-helmet'
import MCEadMenuBar from '../../components/_ead/MenuBar/index'
import NRTEadCoursePage from './_pages/CourseList/_pages/Course/index'
import NRTEadProfilePage from "./_pages/Profile/index"
import NRTEadCourseListPage from "./_pages/CourseList/index"
import MCEadTopBar from "../../components/_ead/TopBar"

class EadHomePage extends Component {

    state = {
        person: null
    }


    static getDerivedStateFromProps(nextProps) {
        return {
            person : _.get(nextProps, 'context.person' )
        }
    }

    componentDidMount() {

        if (!this.props.context.person)
            this.props.history.push('/login/home')

        this.setState({
            person : this.props.context.person
        })
    }


    goToPage = (page) => {
        switch (page) {
            case 'home':
                    return this.props.history.push('/')
            case 'profile':
                    return this.props.history.push('/conta/perfil')
            case 'logout':
                 this.props.context.logout()
                return this.props.history.push('/')

            default:
                this.props.history.push('/conta/' + page)
                break

        }

    }

    render() {

        const {person} = this.state
        const {
            title,
            match,
            context
        } = this.props

        const {page} = match.params

        if (!title || !person )
            return null


        return (

            <div className={'mc-ead-page'}>
                <Helmet>
                    <meta charSet="utf-8"/>
                    <title>{title} | Meus Cursos </title>
                </Helmet>

                <MCEadMenuBar onMenuItemClick={this.goToPage}
                              page={page || ''}
                              logoImgSrc={context.systemConfigParameterValue.logo}
                />

                <div className={'central'}>
                    <div className={'top-bar'}>
                        <MCEadTopBar avatarProfile={person.mainImageUrl}
                                     nameProfile={person.name}
                                     onRouteClick={this.goToPage}
                                     context={context}/>
                    </div>

                    <div className={'content'}>
                        <Switch>
                            <Route path="/conta/curso/:accountCode/:tab?/:tabParam1?/:tabParam2?/:tabParam3?/:tabParam4?"
                                   render={props=><NRTEadCoursePage context={context} {...props}/>}
                            />

                            <Route path={'/conta/perfil/:page?'}
                                   render={props=><NRTEadProfilePage context={context} {...props}/>}
                            />

                            <Route path="/conta/"
                                   render={props=><NRTEadCourseListPage context={context} {...props}/>}
                            />
                        </Switch>
                    </div>
                </div>
            </div>
        )
    }
}

EadHomePage.propTypes = {}
EadHomePage.defaultProps = {}

export default EadHomePage



// WEBPACK FOOTER //
// ./src/_pages/Account/index.js